import type { I18nLocale } from '#/i18n/types/I18nLocale';
import type { DateString, TimeString } from '#/types/TypedDateString';

import { humanDate, shortDate } from './dateString';
import { humanTime } from './timeString';

/**
 * @example
 *
 * Given the date 2024-03-05 and time 11:30:00
 *
 * //=> EN (MMM d, yyyy h:mm a)
 * Mar 5, 2024 11:30 AM
 *
 * //=> ES, PT (MMM d, yyyy H:mm)
 * Mar 5, 2024 11:30
 */
export function humanDatetime(
  dateAndTime: { date: DateString; time: TimeString },
  { locale }: { locale: I18nLocale },
) {
  const { date, time } = dateAndTime;

  return (
    humanDate(date, { locale, monthFormat: 'short' }) +
    ' ' +
    humanTime(time, { locale })
  );
}

/**
 * @example
 *
 * Given the date 2026-04-07 and time 10:00:00
 *
 * //=> EN (d/M/yyyy)
 * 4/7/2026 11:30 AM
 * 4/7/26 11:30 AM (short)
 *
 * //=> ES, PT (M/d/yyyy)
 * 7/4/2026 11:30
 * 7/4/2611:30 AM (short)
 */
export function shortDatetime(
  dateAndTime: { date: DateString; time: TimeString },
  { locale, yearFormat }: { locale: I18nLocale; yearFormat: 'short' | 'long' },
) {
  const { date, time } = dateAndTime;

  return (
    shortDate(date, { locale, yearFormat }) + ' ' + humanTime(time, { locale })
  );
}
